// SwiperSlider.jsx
import React, { useMemo } from "react";
import { Navigation, Pagination, A11y, Zoom } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";

export default function SwiperSlider({ children, className = "swiper-product-details" }) {
  const slides = useMemo(
    () =>
      React.Children.toArray(children).filter(
        (child) => React.isValidElement(child)
      ),
    [children]
  );

  return (
    <Swiper
      id="main"
      modules={[Navigation, Pagination, A11y, Zoom]}
      className={className}
      navigation
      pagination={{ type: "fraction" }}
      zoom={{ maxRatio: 3, toggle: true }}   // let Swiper handle zoom
      slidesPerView={1}
      spaceBetween={16}
      loop={false}
      style={{ willChange: "transform", backfaceVisibility: "hidden" }}
    >
      {slides.map((node, i) => (
        <SwiperSlide key={i}>
          <div className="swiper-zoom-container">
            <div className="swiper-zoom-target">
              {node}
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
